import React, { Component } from 'react';
import { Icon, Header, Divider, Button } from 'semantic-ui-react';
import { base, } from '../../../../config/constants.js'
import * as moment from 'moment';
import { Link } from 'react-router-dom';


class WhatsappConvUi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: ''
        }
    }

    // OLD PHONE
    callSetPhone = () => {
        console.log("1. >> WhatsappConvUi SECOND ONE WhatsappConvUi callSetPhone" + this.props.message.key)
        this.props.setPhone(this.props.message.key)
    }

    componentDidMount() {
        console.log("103 >> mount WhatsappConvUi >> ++++ componentDidMount")
    }

    componentWillUnmount(){
        console.log("103 >>  componentWillUnmount WhatsappMainChatView >> ++++ componentDidMount")
      }

    // callSetPhone = () => {
    //     console.log("SECOND VIEW callSetPhone" + this.props.message.key)
    //     //this.props.setPhoneFunction(this.props.message.key)
    //     this.setState({
    //         phone:this.props.message.key
    //     })
    // }

    setUnReadDone = () => {
        console.log("+++++++ setUnReadDone ++++++")

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');

        var d = new Date();
        let nowSecs = d.getTime()
        let orderUpdate = {
            read: 'yes',
            readSecs: nowSecs,
            redTime: now,
        }

        base
            .remove('whatsapp/latestmessages/' + this.props.message.key)
            .then(() => {
                console.log("whatx1 message deleted:"+this.props.message.key)
                alert(" message deleted:"+this.props.message.key)
            })
            .catch(error => {
                //handle error
            });

        // base.remove('whatsapp/latestmessages/' + this.props.message.key, {
        //     // data: {uid: userUid},
        //     data: orderUpdate,
        //     then: (err) => {
        //         if (!err) {
        //             console.log("updated last message read order no error");

        //         }
        //     }

        // });
    }


    render() {
        return (<div>
            <Header as='h3' >
                <Icon name='whatsapp' />
                <Header.Content>
                    {this.props.message.key}
                    <Header.Subheader> {this.props.message.sentText}</Header.Subheader>
                    <Header.Subheader> {this.props.message.timeSent}</Header.Subheader>
                    <Header.Subheader> READ: {this.props.message.read}</Header.Subheader>
                    <Button.Group>
                    
                        <Button color='orange' size='small' ><Link to={'/dashboard/singleChat/' + this.props.message.key} target="_blank">{this.props.message.key}</Link></Button>
                        <Button onClick={this.setUnReadDone} color='teal' size='small' onClick={this.setUnReadDone}>Done</Button>
                    </Button.Group>

                </Header.Content>

            </Header>
            <Divider />
        </div>

        )
    }
}

export default WhatsappConvUi;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappConvUi.js